import * as angular from 'angular';
import * as _ from "lodash";
import {$addressesFactory} from "../$addresses.factory";
import {Address} from "../models/address.model";
import {IPromise} from "angular";
import {AddressResolverEntryEntity} from "../models/address-resolver-entry.model";
import {BringozApi, BringozApiAction} from "../../persistence-layer/models/bringoz-api.model";

export class AddressesRequests {

  constructor(private addressesAPI: BringozApi, private $addresses: $addressesFactory) {
  }

  getAddresses(quality, query: string, cursor, limit: number) {
    const api = this.addressesAPI.actions.getAddresses;
    return this.$callList(api, {quality: quality, query: query, cursor: cursor, limit: limit}, {}, {});
  }

  getAddress(addressId: string):IPromise<AddressResolverEntryEntity> {
    const api = this.addressesAPI.actions.getAddress;
    return this.objectCall(addressId, api, {}, {}, {}) as IPromise<AddressResolverEntryEntity>;
  }

  validateAddress(addressObj: string) {
    const api = this.addressesAPI.actions.validatedAddress;
    return this.$callList(api, {}, addressObj, {});
  }

  createAddress(address: Address, doUpdate?: boolean) {
    const api = this.addressesAPI.actions.createAddress;
    return this.$callList(api, {updateServices: doUpdate}, address, {});
  }

  updateAddress(address, futureStreetResolution, futureCityResolution,
                updateServices?: boolean, updateAccounts?: boolean) {

    if (!address.validatedAddress || !address.validatedAddress.location) {
      _.set(address, 'validatedAddress.location', address.originalAddress.location);
    }
    const api = this.addressesAPI.actions.updateAddress;
    return this.objectCall(address.id, api, {updateServices: updateServices, updateAccounts: updateAccounts,
      exactAddressResolution: address.exactAddressResolution}, address, {});
  }

  deleteAddress(addressId?: string) {
    const api = this.addressesAPI.actions.deleteAddress;
    return this.objectCall(addressId, api, {}, {}, {});
  }

  getOrdersAndDeliveriesUsingAddress(addressId: string) {
    const api = this.addressesAPI.actions.getOrdersAndServices;
    return this.$callList(api, {}, {}, {addressId: addressId})
  }


  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  private objectCall(id: string, apiCall: BringozApiAction, params: any, data: any, options: any) {
    return this.$addresses(id).$call(apiCall, params, data, options);
  }

  private $callList(apiCall: BringozApiAction, params: any, data: any, options: any) {
    return this.$addresses().$call(apiCall, params, data, options);
  }

}

angular
  .module('bringoz.admin.addresses')
  .service('addressesRequests', AddressesRequests);
